export default "__VITE_ASSET__dc3c5462__"